import { createAsyncThunk, createSlice, isAnyOf } from '@reduxjs/toolkit';

import { errorNotification } from '../../components/notifications';
import api from '../../libs/api';

const initialState = {
  dashboard: {
    rfqCounts: {},
    billCounts: {},
    qcPendingCounts: [],
    formulationApprovalCounts: {},
    productionPlanningStatusCounts: [],
    productCOAPendingCounts: {},
    readyForDispatchVsSalesCounts: {},
    designChangesCounts: {},
    pendingGRCounts: 0,
  },
};

export const getDashboardNumbers = createAsyncThunk(
  'dashboard/getDashboardNumbers',
  async query => {
    const { data } = await api.get('/dashboard', query);

    return data;
  },
);

const dashboard = createSlice({
  name: 'dashboard',

  initialState,

  reducers: {
    clearDashboardNumbers: draft => {
      draft.dashboard = initialState.dashboard;
    },
  },

  extraReducers: builder => {
    builder.addCase(getDashboardNumbers.fulfilled, (draft, { payload }) => {
      draft.dashboard = payload;
    });

    builder.addMatcher(
      isAnyOf(getDashboardNumbers.rejected),
      (_Draft, { error }) => {
        errorNotification(error);
      },
    );
  },
});

export const { clearDashboardNumbers } = dashboard.actions;

export default dashboard.reducer;
